import React from 'react';
import { FaExclamationTriangle, FaHistory } from 'react-icons/fa';
import HistoryCard from './HistoryCard';

function HistoryList({ loading, error, items, emptyMessage }) {
	return (
		<div className='hist-list-wrap'>
			{loading && (
				<div className='hist-loading'>
					<div className='hist-spin' />
					<div className='hist-loading-label'>Cargando historial…</div>
				</div>
			)}
			{!loading && error ? (
				<div className='hist-msg error'>
					<FaExclamationTriangle className='ico' size={16} />
					<div>
						<b>No se pudo cargar el historial</b>
						<div>Ocurrió un error al obtener los cambios. Probá de nuevo.</div>
					</div>
				</div>
			) : !loading && items.length === 0 ? (
				<div className='hist-msg empty'>
					<FaHistory className='ico' size={16} />
					<div>
						<b>Sin cambios registrados</b>
						<div>{emptyMessage}</div>
					</div>
				</div>
			) : !loading && items.length > 0 ? (
				<div className='hist-list'>
					{items.map((entry) => <HistoryCard key={entry.id} entry={entry} />)}
				</div>
			) : null}
		</div>
	);
}

export default HistoryList;
